import { gql } from '@apollo/client';

const GET_PAGES = gql`
  query GetPages {
    pages {
        edges {
            node {
                title
            }
        }
    }
    }
`;

export { GET_PAGES}